import removeNullValues from "@/shared/helpers/remove-null-values.helper";
export const createQuery = (object: any) => {
  const params = removeNullValues(object, {
    removeEmptyArray: true,
    removeEmptyStrings: true
  });
  if (params === null || params === undefined) return "";

  return Object.keys(params).length === 0
    ? ""
    : `?${new URLSearchParams(params).toString()}`;
};
